export const APP_NAME = "Sdtech - Patron";
export const PERSIST_STORE_NAME = "patron";
export const REDIRECT_URL_KEY = "redirectUrl";

export const PER_PAGE = 12;
